import { defineStore } from "pinia";
import { ref } from "vue";
import api from "@/utils/axios";

export const usePermissionStore = defineStore("permissionStore", ()=> {
    const permissions = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const fetchPermissions = async () =>{
        loading.value = true;
        error.value = null;
        try{
            const response = await api.get("/permissions")
            permissions.value = response.data.data;
        }catch(err){
            error.value = "Gagal Memuat Data Permission";
        }finally {
            loading.value=false;
        }
    };

    return {
        permissions,
        loading,
        error,
        fetchPermissions,
    }
})